import { dateFormatter } from "./formatters/date.formatter";
import { enumFormatter } from "./formatters/enum.formatter";

export default {
    install: (app, options = {}) => {
        // Make the formatter available globally
        app.config.globalProperties.$date = dateFormatter;
        app.config.globalProperties.$e = enumFormatter;
    },
};
